import { useNavigate, useParams } from "react-router-dom"

import { Flex, Tabs } from "@/atoms"
import { NAMES_ROUTES, PARAMS } from "@/const/routes.constants"
import { useTranslation } from "@/hooks/useTranslation"
import { HeaderPage } from "@/organisms/HeaderPage"
import {
  PROTECT_SUB_TYPE_POLICY,
  SUPPRESS_SUB_TYPE_POLICY
} from "@/pages/GovernancePage/helpers/policy"
import { PageTemplate } from "@/templates/PageTemplate"
import { TabsTemplate } from "@/templates/TabsTemplate"
import { CreateButtonPolicies } from "./components/CreateButtonPolicies"
import { DescriptionPolicies } from "./components/DescriptionPolicies"
import { ItemTabs } from "./components/ItemTabs"

import type { PoliciesPageComponent } from "."

export const PoliciesPage: PoliciesPageComponent = (props) => {
  const { t } = useTranslation()
  const { type } = props
  const navigation = useNavigate()
  const params = useParams()

  return (
    <PageTemplate
      full
      header={
        <HeaderPage
          titleTranslationKey={t(`governance.policies.${type}.title`)}
        />
      }
    >
      <Flex vertical gap={16}>
        <span />
        <Flex align="flex-start">
          <DescriptionPolicies {...props} />
          <CreateButtonPolicies {...props} />
        </Flex>
        <TabsTemplate>
          <Tabs
            activeKey={params[PARAMS.SUB_TYPE] || PROTECT_SUB_TYPE_POLICY}
            items={[
              ItemTabs({ ...props, subType: PROTECT_SUB_TYPE_POLICY }),
              ItemTabs({ ...props, subType: SUPPRESS_SUB_TYPE_POLICY })
            ]}
            data-testid="tabs-policies"
            onChange={(key) => {
              navigation(`/${NAMES_ROUTES.GOVERNANCE.ROOT}/${type}/${key}`)
            }}
          />
        </TabsTemplate>
      </Flex>
    </PageTemplate>
  )
}
